/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { riskEvalsDeleteReview } from "../funcs/riskEvalsDeleteReview.js";
import { riskEvalsEvaluate } from "../funcs/riskEvalsEvaluate.js";
import { riskEvalsListReviews } from "../funcs/riskEvalsListReviews.js";
import { riskEvalsSaveReview } from "../funcs/riskEvalsSaveReview.js";
import { ClientSDK, RequestOptions } from "../lib/sdks.js";
import { ListRiskEvalReviewsResult } from "../models/components/listriskevalreviewsresult.js";
import { PromptGuardrailEvalResult } from "../models/components/promptguardrailevalresult.js";
import { RiskPolicyEvalReview } from "../models/components/riskpolicyevalreview.js";
import {
  DeleteRiskEvalReviewRequest,
  DeleteRiskEvalReviewSecurity,
} from "../models/operations/deleteriskevalreview.js";
import {
  EvaluatePromptGuardrailRequest,
  EvaluatePromptGuardrailSecurity,
} from "../models/operations/evaluatepromptguardrail.js";
import {
  ListRiskEvalReviewsRequest,
  ListRiskEvalReviewsSecurity,
} from "../models/operations/listriskevalreviews.js";
import {
  SaveRiskEvalReviewRequest,
  SaveRiskEvalReviewSecurity,
} from "../models/operations/saveriskevalreview.js";
import { unwrapAsync } from "../types/fp.js";

export class Evals extends ClientSDK {
  /**
   * deleteRiskEvalReview risk
   *
   * @remarks
   * Remove the current reviewer's verdict for one session (the toggle-off path). A reviewer can only clear their own verdict.
   */
  async deleteReview(
    request: DeleteRiskEvalReviewRequest,
    security?: DeleteRiskEvalReviewSecurity | undefined,
    options?: RequestOptions,
  ): Promise<void> {
    return unwrapAsync(riskEvalsDeleteReview(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * evaluatePromptGuardrail risk
   *
   * @remarks
   * Replay a prompt_based guardrail against a single chat session and return the LLM judge's per-message verdict. The guardrail (prompt + judge config + message-type scope + CEL scope) is passed inline so the policy-eval workbench can evaluate an unsaved draft before a policy exists. This path is read-only: it never writes risk_results, publishes to the outbox, or enforces. It exists purely to tune a guardrail against real transcripts. Judges only the chat's latest generation and at most the first 200 in-scope messages in transcript order; message-type scoping and CEL scope predicates are both applied.
   */
  async evaluate(
    request: EvaluatePromptGuardrailRequest,
    security?: EvaluatePromptGuardrailSecurity | undefined,
    options?: RequestOptions,
  ): Promise<PromptGuardrailEvalResult> {
    return unwrapAsync(riskEvalsEvaluate(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * listRiskEvalReviews risk
   *
   * @remarks
   * List the active regression set for a prompt-based policy: every reviewer's current ground-truth verdicts.
   */
  async listReviews(
    request: ListRiskEvalReviewsRequest,
    security?: ListRiskEvalReviewsSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ListRiskEvalReviewsResult> {
    return unwrapAsync(riskEvalsListReviews(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * saveRiskEvalReview risk
   *
   * @remarks
   * Record (or replace) the current reviewer's ground-truth verdict for one chat session under a prompt-based policy. This is the durable regression set the eval workbench scores the live guardrail against. Upserts: a reviewer has at most one verdict per session per policy.
   */
  async saveReview(
    request: SaveRiskEvalReviewRequest,
    security?: SaveRiskEvalReviewSecurity | undefined,
    options?: RequestOptions,
  ): Promise<RiskPolicyEvalReview> {
    return unwrapAsync(riskEvalsSaveReview(
      this,
      request,
      security,
      options,
    ));
  }
}
